import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { clusters } from "@/data/clusters";

const MAP_PATH =
  "M120 28 L150 22 L168 34 L160 52 L182 60 L205 50 L222 64 L210 86 L232 96 L250 120 L242 150 L262 168 L250 196 L262 222 L240 250 L250 286 L228 300 L214 332 L196 352 L182 330 L172 300 L150 288 L138 256 L120 244 L108 210 L92 196 L84 162 L98 140 L86 112 L100 86 L92 60 L108 44 Z";

export const ClusterMap = ({ initialId = null, showDetail = true }) => {
  const [activeId, setActiveId] = useState(initialId);
  const active = clusters.find((c) => c.id === activeId);

  useEffect(() => {
    setActiveId(initialId);
  }, [initialId]);

  return (
    <div className="cluster-map-component">
      <div className="map-wrap">
        <svg
          className="map"
          viewBox="0 0 340 380"
          role="group"
          aria-label="Manufacturing clusters across India"
          data-testid="cluster-map"
        >
          <path className="land" d={MAP_PATH} />
          {clusters.map((c) => {
            const isActive = c.id === activeId;
            const lx = c.coords.x + (c.labelOffset?.x ?? 0);
            const ly = c.coords.y + (c.labelOffset?.y ?? -12);
            return (
              <g
                key={c.id}
                className={`node ${isActive ? "active" : ""}`}
                tabIndex={0}
                role="button"
                aria-label={`${c.name} — ${c.material}`}
                onClick={() => setActiveId(c.id)}
                onFocus={() => setActiveId(c.id)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setActiveId(c.id);
                  }
                }}
                data-testid={`cluster-node-${c.id}`}
              >
                <circle className="ring" cx={c.coords.x} cy={c.coords.y} r={5} />
                <circle className="hit" cx={c.coords.x} cy={c.coords.y} r={10} />
                <circle className="dot" cx={c.coords.x} cy={c.coords.y} r={4} />
                <text x={lx} y={ly} textAnchor={c.labelAnchor || "middle"}>
                  {c.name}
                </text>
              </g>
            );
          })}
        </svg>
      </div>

      {showDetail && (
        <div className="map-read" aria-live="polite" data-testid="cluster-detail">
          {active ? (
            <>
              <p className="mono">{active.material}</p>
              <p className="name">{active.name}</p>
              <p className="spec">{active.spec}</p>
              <div className="cluster-detail">
                <div>
                  <span>MOQ</span>
                  <strong>{active.detail.moq}</strong>
                </div>
                <div>
                  <span>Lead</span>
                  <strong>{active.detail.lead}</strong>
                </div>
                <div>
                  <span>Certs</span>
                  <strong>{active.detail.certs}</strong>
                </div>
              </div>
              <Link
                to={`/clusters/${active.id}`}
                className="btn btn-ghost on-dark"
                style={{ marginTop: "1.1rem", paddingLeft: 0 }}
                data-testid={`map-view-${active.id}`}
              >
                View {active.name} →
              </Link>
            </>
          ) : (
            <>
              <p className="mono">Select a city</p>
              <p className="name">The map</p>
              <p className="spec">
                Brass, blue pottery, glass, carved wood and textile — sourced where the craft actually lives.
              </p>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ClusterMap;
